/* eslint-disable import/prefer-default-export */
export const fr = {
  translation: {
    title: 'Valider la copie électronique autorisée',
    desc:'Saisissez le CSV (Code sécurisé de vérification) et appuyez sur le bouton Valider pour vérifier l’authenticité et l’intégrité de la copie électronique autorisée du document notarié, ainsi que pour consulter les notes ultérieures de modification juridique et de coordination avec d’autres instruments publics.',
    placeholderCSV:'Code CSV',
    validateButton: 'Valider',
    backButton:'Retour',
    okButton:'Accepter',
    cancelButton:'Annuler',
    closeButton:'Fermer',
    actionsButton:'Actions',
    downloadButton:'Télécharger',
    head:{
      title: 'PORTAIL ÉLECTRONIQUE NOTARIAL',
    },
    footer:{
      legalNotice: 'Mentions légales',
      privacyPolicy: 'Politique de confidentialité',
      accessibility: 'Accessibilité',
      cookiesPolicy: 'Politique relative aux cookies',
      supportedBrowsers: 'Navigateurs pris en charge',
    },
    modalsupportedbrowsers:{
      other: 'Vous pouvez accéder en utilisant un PC, Mac, mobile ou tablette.',
    },
    actions: {
      helpButton:'Voir l’aide',
      validateSignature:'Valider la signature',
      download:'Télécharger',
      downloadCombined: 'Télécharger combinés'
    },
    modalAyuda:{
      title:'Aide',
      guide:'Vous pouvez télécharger ici le guide associé à cette section',
      section1: 'Vérifier la validité de la signature via le portail électronique notarial',
      desc1: 'Pour vérifier la validité de la signature électronique qualifiée du notaire sur le document notarié, cliquez sur le bouton <strong>Actions</strong> et sélectionnez <strong>Valider la signature</strong>.',
      section2: 'Vérifier la validité de la signature avec Adobe Acrobat Reader',
      desc2: 'Pour vérifier la validité de la signature électronique qualifiée du notaire sur le document notarié, cliquez sur le bouton <strong>Actions</strong> et sélectionnez <strong>Télécharger</strong>. Ensuite, ouvrez le document avec Adobe Acrobat Reader et cliquez sur l’icône du stylo située dans le menu latéral. <br /><br /> Dans la liste déroulante, vous pourrez vérifier la validité de la signature et analyser ses détails.',
      section3: 'Vérifier la validité de la signature avec VALIDe',
      desc3: 'Pour vérifier la validité de la signature électronique qualifiée du notaire sur le document notarié, cliquez sur le bouton <strong>Actions</strong> et sélectionnez <strong>Télécharger</strong>. Ensuite, utilisez la',
      linkText: 'plateforme publique VALIDe',
    },
    modalCopia:{
      title:'Copie électronique autorisée',
    },
    modalErrorServicio:{
      desc: 'Il n’existe aucune copie électronique autorisée associée au code CSV que vous avez saisi. Veuillez vérifier le code et réessayer.',
      contactSupport: 'Si le problème persiste, vous pouvez contacter le service d’assistance.',
    },
    modalAdvertenciaDescarga:{
      title:'Avertissement',
      desc:'<strong>Les notes</strong> de modification juridique et de coordination avec d’autres instruments publics <strong>émises après la délivrance de la copie ne seront pas disponibles dans le document que vous allez télécharger.</strong> Elles figurent uniquement sur le justificatif de délivrance.',
    },
    modalErrorGenerico:{
      desc:'Un problème est survenu. Veuillez réessayer.',
    },
    modalErrorValidacion:{
      title:'Erreur de validation de la signature.',
      desc:'La signature du document n’a pas pu être validée. Veuillez réessayer ou contacter le service d’assistance.',
    },
    modalManuales:{
      name:'Nom',
    },
    modalValidacionFirma:{
      title:'Valider la signature',
      firmaNotario:'SIGNATURE QUALIFIÉE DU NOTAIRE :',
      fechaFirma:'DATE DE LA SIGNATURE :',
      fechaValidacion:'DATE DE VALIDATION :',
      estadoFirma:'ÉTAT DE LA SIGNATURE :',
      validacionFirma:'Validation de la signature électronique du Conseil Général du Notariat',
      validada:'Validée',
      noValidada:'Non valide',
      contenido:'Contenu du document',
      alterado:'modifié',
      noAlterado:'non modifié',
      certificadoFirmante:'Certificat du signataire',
      caducado:'expiré',
      noCaducado:'non expiré',
      revocado:'révoqué',
      noRevocado:'non révoqué',
      certificadoCa:'émis par une autorité de certification de confiance (CA)',
      noCertificadoCa:'non émis par une CA de confiance',
    },
  },
};
